import { REFS_BY_TYPE_LABELS_MAP } from "../constants.js";
import { EventCard } from "../../../Events/shared/EventCard.js";
import { LocationCard } from "../../../Locations/shared/LocationCard.js";
import { LocationLogEntryCard } from "../../../Locations/shared/LocationLogEntries/LocationLogEntryCard.js";
import { RecordCard } from "../../../Records/shared/RecordCard.js";
import { ReportCard } from "../../../Reports/shared/ReportCard.js";
import { UserCard } from "../../../Users/shared/UserCard.js";
import { ShowHideContent } from "../../../../components/ShowHideContent/index.js";
import { isEven } from "../../../../utils/isEvenNumber.js";
import { isOdd } from "../../../../utils/isOddNumber.js";
import "react";
import { Badge, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandMore } from "react-icons/md";
//#region src/modules/shared/RefsByTypeTitles/components/RefCardsList.tsx
function RefCardListItem({ ids, type }) {
	return /* @__PURE__ */ jsx(ShowHideContent, {
		label: /* @__PURE__ */ jsxs("div", {
			className: "gap-x-sm flex items-center justify-between",
			children: [/* @__PURE__ */ jsx("span", {
				className: "font-bold",
				children: REFS_BY_TYPE_LABELS_MAP[type].single
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex items-center justify-center text-sm",
				children: [/* @__PURE__ */ jsx(Badge, { value: ids.length }), /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore })]
			})]
		}),
		children: /* @__PURE__ */ jsx("div", {
			className: "space-y-xxs",
			children: ids.map((id) => typeComponents[type](id))
		})
	}, type);
}
var typeComponents = {
	eventIds: (id) => /* @__PURE__ */ jsx(EventCard, { eventId: id }, id),
	locationIds: (id) => /* @__PURE__ */ jsx(LocationCard, { locationId: id }, id),
	locationLogEntryIds: (id) => /* @__PURE__ */ jsx(LocationLogEntryCard, { entryId: id }, id),
	recordIds: (id) => /* @__PURE__ */ jsx(RecordCard, { recordId: id }, id),
	reportIds: (id) => /* @__PURE__ */ jsx(ReportCard, { reportId: id }, id),
	userIds: (id) => /* @__PURE__ */ jsx(UserCard, { userId: id }, id)
};
function RefCardsList({ refsByType }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-wrap",
		children: [/* @__PURE__ */ jsx("div", {
			className: "space-y-xs md:pr-xs w-full md:w-1/2",
			children: Object.entries(refsByType).map(([type, ids], index) => !!ids?.length && isEven(index) && /* @__PURE__ */ jsx(RefCardListItem, {
				type,
				ids
			}, type))
		}), /* @__PURE__ */ jsx("div", {
			className: "space-y-xs md:pr-xs w-full md:w-1/2",
			children: Object.entries(refsByType).map(([type, ids], index) => !!ids?.length && isOdd(index) && /* @__PURE__ */ jsx(RefCardListItem, {
				type,
				ids
			}, type))
		})]
	});
}
//#endregion
export { RefCardsList };

//# sourceMappingURL=RefCardsList.js.map